// profitFormat.js — shared money formatters for the profit UI (CP Approvals tooltips,
// Styles table, SPF tabs). Extracted 2026-10-03 (revamp §5.4) from CpApprovalsPage.js and
// ProfitMeasurerPage.js, which each carried a byte-identical copy. One source of truth now.
export function n0c(v) { return (v == null || isNaN(v)) ? "—" : Math.round(Number(v)).toLocaleString("en-IN"); }
export function n2c(v) { return (v == null || isNaN(v)) ? "—" : Number(v).toFixed(2); }
